export default __webpack_public_path__ + "static/media/OMIVisitor_2022_RLDynamicConvex.e06eb80c.pdf";